import { chatsActions } from "../../actionTypes";

const initialState = {
	message: {},
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case chatsActions.CREATE_MESSAGE: {
			return { ...initialState, fetching: true };
		}

		case chatsActions.CREATE_MESSAGE_FULFILLED: {
			return {
				...state,
				fetching: false,
				fetched: true,
				message: action.payload,
			};
		}

		case chatsActions.CREATE_MESSAGE_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
	}

	return state;
};

export default Reducer;
